import { z } from "zod/v4";
import { type QueryRowType } from "@rocicorp/zero";
import { defineQuery } from "../../zero/transformer";
import { zql } from "../../zero/schema";
import { BODY_METRIC_GROUP_TYPES, BODY_METRIC_KEYS } from "./constants";

/**
 * Body metric namespace boundary.
 *
 * Exposes the stable metric catalog used by clients for tracking, validation,
 * and UI grouping.
 */
export namespace BodyMetric {
  export const all = defineQuery(z.undefined(), () => zql.bodyMetric);
  export type Info = QueryRowType<typeof all>;

  export const keySchema = z.enum(BODY_METRIC_KEYS);
  export type Key = (typeof BODY_METRIC_KEYS)[number];

  export const GROUP_TYPES = BODY_METRIC_GROUP_TYPES;
  export type GroupType = (typeof BODY_METRIC_GROUP_TYPES)[number];
  export const groupTypeSchema = z.enum(BODY_METRIC_GROUP_TYPES);

  export const MASS_MAX = { kg: 650, lb: 1433 } as const;
  export const HEIGHT_MAX = { cm: 300, in: 118 } as const;
}
